package com.evoapps.evoshift.domain.usecase.settings

import com.evoapps.evoshift.domain.model.CostFrequency
import com.evoapps.evoshift.domain.model.RecurringCostRule
import com.evoapps.evoshift.domain.repository.WorkplaceRepository

class CreateRecurringCostRuleUseCase(
    private val workplaceRepository: WorkplaceRepository
) {
    suspend operator fun invoke(ownerId: String, rule: RecurringCostRule): Result<Unit> {
        return try {
            // Walidacja: Czy kwota dodatnia?
            if (rule.amount < 0) throw IllegalArgumentException("Cost cannot be negative")
            // A one-off expense belongs to a month (AddOneOffCostUseCase, SH-84), not to the rules.
            require(rule.frequency != CostFrequency.ONE_OFF) { "A recurring rule cannot be one-off" }

            // Zapisz regułę w owners/{uid}/recurring_cost_rules
            workplaceRepository.createRecurringCostRule(ownerId, rule).getOrThrow()
            Result.success(Unit)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}